import React, { Fragment } from "react";
import PageHeader from "../common/components/PageHeader";
import { Box, Grid, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Check, Close, FiberManualRecord } from "@mui/icons-material";
import CommonButton from "../common/components/CommonButton";
import { FeatureList, Plans } from "../common/const";
import CommonCard from "../common/components/CommonCard";

const Subscription = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Fragment>
            <PageHeader
                title="Subscription"
                content={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.secondary" sx={{ fontSize: 14,  }}>
                            Home
                        </Typography>
                        <FiberManualRecord sx={{ fontSize: 8, color: 'text.secondary' }} />
                        <Typography color="text.secondary" sx={{ fontSize: 14,  }}>
                            Subscription
                        </Typography>
                    </Stack>
                }
            />
            <Box
                sx={{
                    background: theme.palette.secondary.main,
                    padding: '15px 20px 15px 20px',
                    borderRadius: 1,
                    mt: 2,
                    display: 'flex',
                    gap: isMobile ? 2 : 0,
                    justifyContent: 'space-between',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    flexDirection: isMobile ? 'column' : 'row'
                }}
            >
                <Box
                    display="flex"
                    gap={1.5}
                    alignItems="center"
                >
                    <img
                        src="/Images/subscription-logo.png"
                        alt="subscription-logo"
                        height="70px"
                    />
                    <Box>
                        <Box display="flex" gap={1} alignItems="center">
                            <Typography variant="h5" color="white">Gold Plan</Typography>
                            <Box
                                sx={{
                                    background: theme.palette.success.light,
                                    textAlign: 'center',
                                    borderRadius: 0.8,
                                    width: 60,
                                    height: 25
                                }}
                            >
                                <Typography sx={{ color: theme.palette.success.main }}>Active</Typography>
                            </Box>
                        </Box>
                        <Typography color="white" sx={{ fontSize: 13 }}>Expired in <span style={{ color: theme.palette.primary.main, fontWeight: 700 }}>25 Dec, 2025</span></Typography>
                    </Box>
                </Box>
                <CommonButton
                    label="Upgrade Plan"
                    size="md"
                    width={isMobile ? "30%" : "10%"}
                    marginBottom="0"
                />
            </Box>
            <Grid container spacing={isMobile ? 0 : 2}>
                {Plans.map((a) => (
                    <Grid item sm={12} md={6} lg={3} sx={{ width: '100%' }}>
                        <CommonCard
                            headerContent={
                                <Box
                                    sx={{
                                        background: theme.palette.plan[a.name],
                                    }}
                                >
                                    {a.name === 'Gold' && (
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                background: theme.palette.primary.main,
                                                p: 0.5
                                            }}
                                        >
                                            <Typography color="background.main" variant="body2" sx={{ fontWeight: 600 }}>
                                                Most Popular
                                            </Typography>
                                        </Box>
                                    )}
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                    >
                                        <img
                                            src={`/Images/${a.name}.png`}
                                            alt="subscription-logo"
                                            height="70px"
                                            style={{
                                                margin: a.name === 'Gold' ? '5px 10px 7px 20px' : '20px 10px 20px 20px'
                                            }}
                                        />
                                        <Box sx={{ width: '100%' }}>
                                            <Box display="flex" gap={1} alignItems="center" justifyContent="space-between">
                                                <Typography variant="h5">{a.name}</Typography>
                                                {a.isActive && (
                                                    <Box
                                                        sx={{
                                                            background: theme.palette.background.main,
                                                            textAlign: 'center',
                                                            borderRadius: 0.8,
                                                            width: 60,
                                                            height: 25,
                                                            marginRight: 1
                                                        }}
                                                    >
                                                        <Typography sx={{ color: theme.palette.success.main }}>Active</Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                            <Typography sx={{ fontWeight: 600 }}>${a.price} <span style={{ color: theme.palette.icon.light, fontWeight: 'normal' }}>/ month</span></Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            }
                            content={
                                FeatureList.map((i, index) => (
                                    <Box display="flex" alignItems="center" gap={1} key={index} pt={1} pl={1}>
                                        {a.features.includes(i.id) ? <Check sx={{ color: theme.palette.success.main, fontSize: 20 }}/> :  <Close sx={{ color: theme.palette.background.dark, fontSize: 20 }}/>}
                                        <Typography color={a.features.includes(i.id) ? 'black' : theme.palette.background.dark}>{i.title}</Typography>
                                    </Box>
                                ))
                            }
                            footerContent={
                                <CommonButton
                                    label={a.isActive ? 'Current Plan' : a.name === 'Free' ? 'Continue Free' : `Upgrade To ${a.name}`}
                                    size="md"
                                    marginBottom="0"
                                    background={a.isActive ? 'background.secondary' : 'primary.main'}
                                />
                            }
                            borderRadius={1}
                            border={`1px solid #0000001A`}
                        />
                    </Grid>
                ))}
            </Grid>
        </Fragment>
    )
}

export default Subscription;